import $api from "../../../../services/axiosService";

import { getAllUserRequestsAction } from "../getAllUserRequests.action";
import RequestServices from "../../../../../frontend.services/RequestServices/RequestServices";

import { mode } from "../../../../../app/mode";

import { element } from "prop-types";


// TODO REFACTOR
export const getUserRequestsThunkAction = (props) => async (dispatch) => {

    try {
        // if (mode === "TEST" || mode === "PROD") {
        //     const response = await $api("v2/request/all/for/po");
        //     if (response.status === 200) {
        //         const data = await RequestServices.getUserRequestsWithFile(response.data.items);
        //         dispatch(getAllUserRequestsAction(data));
        //     }
        // } else {
        if (props.page) {
            const { page } = props;
            const response = await $api("v1/applications", {
                params: props.page,
            });
            if (response.status === 200) {
                const temp = response.data;
                const data = response.data?.items.map((element) => {
                    return {
                        ...element, typeText: "Заявка",
                    };
                });
                temp.items = data;
                dispatch(getAllUserRequestsAction(temp));
            }
        } else {
            const response = await $api("v1/applications", {
                params: {
                    pageSize: 5,
                    pageNumber: 1,

                },
            });
            if (response.status === 200) {
                const temp = response.data;
                const data = response.data?.items.map((element) => {
                    return {
                        ...element, typeText: "Заявка",
                    };
                });
                temp.items = data;
                dispatch(getAllUserRequestsAction(temp));
            }
        }

        // }


    } catch (e) {
        if (props) {
            props.setErrDescription("Что-то пошло не так, повторите попытку позже.");
            props.setErrorModal(true);
        }
        // console.log("ERROR WHILE GETTING USER REQUESTS: ", e.response)
    }
};
